import {Tag} from 'antd';
import React from 'react';

/**
 * Used for places with only one tag.
 * (For places with multiple tags, eg each transaction table list, we use fading-div for now)
 * @param {*} props
 */
function BukkuEllipsisTag(props) {
    const {
        children,
        className,
        ...restProps
    } = props;

    return (
        <span style={{display: "inline-grid"}}>
            <Tag
                className={className ? `${className} ellipsis-tag` : 'ellipsis-tag'}
                {...restProps}
            >
                {children}
            </Tag>
        </span>
    );
}

export default BukkuEllipsisTag;
